/**
 * Custom Error class representing an invalid date format error.
 */
export class InvalidDateError extends Error {
    /** Static error code to identify the error type. */
    static ERROR = 'InvalidDateError'
    /** Expected date format that caused the error. */
    format?: string
    /** Date value that failed validation. */
    value?: string

    /**
     * Creates a new InvalidDateError.
     *
     * @param {string} [format] - Expected date format that caused the error.
     * @param {string} [value] - Date value that failed validation.
     * @param {string} [message] - Optional custom error message.
     */
    constructor(format?: string, value?: string, message?: string) {
        super(message)
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain

        this.name = InvalidDateError.ERROR
        this.format = format
        this.value = value
        this.stack = new Error().stack

        if (format && value) {
            this.message = `Invalid date ${value}. Required format: ${format}`
        }
    }
}
